module.exports = __webpack_public_path__ + "img/BUSINESSFOCUS.7059ee4f.png";